import { TYPES } from "@/types";
import { myContainer } from "@/inversify.config";
import { IEmploymentService } from "@/interfaces/IEmploymentService";
import * as dtos from "@/models/dtos";
import { FormBuilder2 } from "../../models/FormBuilder2";
import {
  MetaData,
  DynamicProperty,
  PositionTemplateRequest,
} from "../../models/dtos";
import FormInputList from "@/features/shared/components/form/FormInputList.vue";
import { FormItemModel } from "../../models/CheckboxGroup";
import { PositionTemplateFolder } from "@/models/PositionTemplateFolder";
import { Buffer } from "buffer";

import { PositionTemplateAsset } from "@/models/PositionTemplateFolder";
import moment from "moment";
import { ToastNotification } from "@/models/ToastNotification";
const client = myContainer.get<IEmploymentService>(TYPES.IEmploymentService);

export default {
  state: {
    form: {} as FormBuilder2,
    formBuillderPosition: new dtos.PositionResponse(),
    formbuilderCurrentView: {} as FormItemModel,
    counter: 1000,
    formTemplateFolder: {} as PositionTemplateFolder,
    formTemplates: [] as PositionTemplateAsset[],
  },

  getters: {
    form: (state: any) => state.form,
    formView: (state: any) => state.formbuilderCurrentView,
    formTemplateFolder(state: any) {
      return state.formTemplateFolder;
    },
    formTemplateAsset: (state: any) => (formTemplateKey: string) => {
      return state.formTemplateFolder.Assets.find(
        (x: PositionTemplateAsset) => x.data.key === formTemplateKey
      );
    },
    formTemplates: (state: any) => state.formTemplates,
    formTemplate: (state: any) => (id: number | string) => {
      if (typeof id === "string") {
        return state.formTemplates.find(
          (x: PositionTemplateAsset) => x.data.key === id
        );
      }
      return state.formTemplates.find(
        (x: PositionTemplateAsset) => x.id === id
      );
    },
    formTemplatesByPositionId: (state: any) => (positionTypeId: number) => {
      return state.formTemplates.filter((x: PositionTemplateRequest) => {
        return x.availableInPositionTypes.find(
          (y) => y.positionTypeId === positionTypeId
        );
      });
    },
  },

  mutations: {
    setFrombuilder(state: any, item: MetaData) {
      state.form = new FormBuilder2(item, false);
    },
    setFrombuilder2(state: any, item: MetaData) {
      state.form = new FormBuilder2(item, true);
    },
    resetFormbuilder(state: any) {
      state.form = new FormBuilder2(new MetaData(), false);
    },
    setFormView(state: any, item: any) {
      state.formbuilderCurrentView = item;
    },
    setPosition(state: any, item: dtos.PositionResponse) {
      state.formBuillderPosition = item;
    },
    setFormTemplateFolder(state: any, item: PositionTemplateFolder) {
      state.formTemplateFolder = item;
    },
    setFormTemplates(state: any, item: PositionTemplateRequest[]) {
      state.formTemplates = item;
    },
  },

  actions: {
    async setPosition({ commit }: any, item: dtos.PositionResponse) {
      commit("setPosition", item);
    },
    async setFrombuilder({ commit }: any, item: MetaData) {
      commit("setFrombuilder", item);
      const _item = new FormItemModel(FormInputList, new DynamicProperty());
      _item.editView = FormInputList;
      commit("setFormView", _item);
    },
    async setFrombuilder2({ commit }: any, item: MetaData) {
      commit("setFrombuilder2", item);
      const _item = new FormItemModel(FormInputList, new DynamicProperty());
      _item.editView = FormInputList;
      commit("setFormView", _item);
    },
    setFormView({ commit }: any, item: any) {
      commit("setFormView", item);
    },
    async loadFormTemplateFolder({ getters, dispatch, commit }: any) {
      let folderId = getters?.getPositionTemplateFolder?.id;
      if (!folderId) await dispatch("loadContainerFolders");

      folderId = getters?.getPositionTemplateFolder?.id;
      if (!folderId)
        await dispatch("createContainerFolder", "PositionTemplates");

      folderId = getters?.getPositionTemplateFolder?.id;
      if (!folderId)
        throw new Error("Hittade inga mallar, vänligen kontakta support");

      const folder = await client.Container.getFolder(
        getters.container.id,
        folderId
      );
      const templateFolder = new PositionTemplateFolder(folder);
      commit("setFormTemplateFolder", templateFolder);
      commit("setFormTemplates", templateFolder.Assets);
    },

    async loadFormTemplates({ getters, commit, dispatch }: any) {
      let folderId = getters?.getPositionTemplateFolder?.id;
      if (!folderId) await dispatch("loadContainerFolders");

      folderId = getters?.getPositionTemplateFolder?.id;

      const folder = await client.Container.getFolder(
        getters.container.id,
        folderId
      );
      const model = new PositionTemplateFolder(folder);

      commit("setFormTemplates", model.Assets);
    },
    async loadFormTemplate(
      { getters, dispatch, state }: any,
      id: number | string
    ) {
      if (state.formTemplates.length === 0) await dispatch("loadFormTemplates");
      if (state.formTemplates.length === 0) throw new Error("No templates");

      return getters.formTemplate(id).data as PositionTemplateRequest;
    },
    async getOrCreateFormTemplate(
      { getters, dispatch }: any,
      id?: number | string
    ) {
      if (id) {
        return await dispatch("loadFormTemplate", id);
      } else {
        const template = new PositionTemplateRequest();
        template.folderId = getters?.getPositionTemplateFolder?.id;
        template.key = crypto.randomUUID();
        template.name = "";
        template.description = "";
        template.createdAt = moment().unix();
        template.createdBy = getters?.getLoggedInUser as dtos.UserResponse;
        template.availableInPositionTypes =
          getters?.container?.positionTypes.map((x: any) => {
            return {
              positionTypeId: x.id,
              positionTypeName: x.name,
              included: false,
              default: false,
            };
          });
        template.metadata = new MetaData();

        return template;
      }
    },
    async saveFormTemplate(
      { getters, dispatch, state, commit }: any,
      template: PositionTemplateRequest
    ) {
      // check if template already exists
      const existingTemplate = state.formTemplates.find(
        (x: PositionTemplateAsset) => x.data.key === template.key
      );

      let id = 0;
      if (existingTemplate) id = existingTemplate.id;

      // encode template to base64
      const encode = (str: string): string =>
        Buffer.from(str, "utf-8").toString("base64");

      // convert template to json
      const dataString = JSON.stringify(template);

      // create new template
      await client.Container.createPositionTemplateAsset(
        id,
        getters.container.id,
        getters.getPositionTemplateFolder.id,
        encode(dataString),
        "application/json",
        template.name
      );
      await dispatch("reloadContainer");
      await dispatch("loadFormTemplates"); // reload templates from backend
    },
    async deleteFormTemplate({ getters, dispatch }: any, templateId: number) {
      await client.Container.deleteContainerAsset(
        getters.container.id,
        getters.getPositionTemplateFolder.id,
        templateId
      );
      await dispatch(
        "addNotification",
        new ToastNotification("success", "Mall borttagen")
      );
      await dispatch("reloadContainer");
      await dispatch("loadFormTemplates"); // reload templates from backend
    },
    selectRadioButton(
      { getters, commit }: any,
      item: {
        parentKey: string;
        keyToSelect: string;
        adminView?: boolean;
      }
    ) {
      let form = getters.form;

      if (!form?.metadata?.properties || item.adminView) {
        form = getters.positionApplicant.Applicant;
      }
      const allRadioKeys = form.metadata.properties.find(
        (x: DynamicProperty) => x.key === item.parentKey
      )?.data?.keys;
      if (!allRadioKeys) return;

      const child = form.metadata.properties.find(
        (x: DynamicProperty) => x.key === item.keyToSelect
      );
      if (!child) return;

      allRadioKeys.forEach((x: string) => {
        const childToUnselect = form.metadata.properties.find(
          (y: DynamicProperty) => y.key === x
        );
        if (!childToUnselect) return;
        childToUnselect.data = false;
      });
      child.data = true;
      commit("setFrombuilder", form.metadata);
    },
    toggleIsRequired(
      { getters, commit }: any,
      item: {
        key: string;
        value: boolean;
      }
    ) {
      const form = getters.form;
      if (!form?.metadata?.properties) return;

      const propToChange = form.metadata.properties.find(
        (x: DynamicProperty) => x.key === item.key
      );
      if (!propToChange) return;

      const validator = propToChange?.validators?.find(
        (validator: any) => validator.name === "radioRequired"
      );

      if (validator) {
        propToChange?.validators.splice(
          propToChange?.validators.indexOf(validator),
          1
        );
      }

      const required = new dtos.PropertyValidator("radioRequired", item.value);

      propToChange?.validators.push(required);

      commit("setFrombuilder", form.metadata);
    },
  },
};
